import { render, staticRenderFns } from "./SalePaymentView.vue?vue&type=template&id=55a5acea"
import script from "./SalePaymentView.vue?vue&type=script&lang=js"
export * from "./SalePaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports